import { useEffect, useMemo, useState } from 'react';

export type AudienceBuilderSegment = {
  code: string;
  in_target_reach?: number;
  segment_reach?: number;
  short_name?: string;
};

type AudienceBuilderSegmentsResponse = {
  data?: AudienceBuilderSegment[];
};

const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || 'https://api.digiseg.net').replace(/\/+$/, '');
const SEGMENT_ENDPOINT = `${API_BASE_URL}/taxonomy/audiencebuilder_segments`;

export const useAudienceBuilderSegments = () => {
  const [segments, setSegments] = useState<AudienceBuilderSegment[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<unknown>(null);

  useEffect(() => {
    let cancelled = false;
    setIsLoading(true);

    fetch(SEGMENT_ENDPOINT)
      .then((resp) => resp.json())
      .then((payload: AudienceBuilderSegmentsResponse) => {
        if (cancelled) return;
        setSegments(Array.isArray(payload?.data) ? payload.data : []);
      })
      .catch((err) => {
        if (cancelled) return;
        setError(err);
        console.error('Failed to load audience builder segments', err);
      })
      .finally(() => {
        if (!cancelled) setIsLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  const segmentMap = useMemo(
    () => new Map(segments.map((segment) => [segment.code, segment])),
    [segments],
  );

  return { segments, segmentMap, isLoading, error };
};
